import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import App from './components/App.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<App />);
